<template>
<div class="chapter">
<div class="inner_page">
<h2 class="TOC-FBMHD">Contents</h2>
<h2 class="TOC-FBMHD"><a href="#/int">Introduction</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c01">Tools &amp; equipment</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c02">Recipes</a></h2>
<p class="TOC-AHD"><a href="#/c03">Cupcake recipes</a></p>
<p class="TOC-AHD"><span href="#/c10" title="Link target outside of Sample">Topping recipes</span></p>
<h2 class="TOC-FBMHD"><span href="#/c19" title="Link target outside of Sample">Techniques</span></h2>
<p class="TOC-AHD"><span href="#/c20" title="Link target outside of Sample">Applying frostings</span></p>
<p class="TOC-AHD"><span href="#/c24" title="Link target outside of Sample">Using sugarpaste</span></p>
<p class="TOC-AHD"><span href="#/c28" title="Link target outside of Sample">Creating features</span></p>
<p class="TOC-AHD"><span href="#/c32" title="Link target outside of Sample">Special finishes</span></p>
<p class="TOC-AHD"><span href="#/c33" title="Link target outside of Sample">Presentation &amp; display</span></p>
<p class="TOC-AHD"><span href="#/c34" title="Link target outside of Sample">Storage &amp; transportation</span></p>
<h2 class="TOC-CH-T"><span href="#/c35" title="Link target outside of Sample">Barnyard fun</span></h2>
<p class="TOC-AHD"><span href="#/c36" title="Link target outside of Sample">Little lambs</span></p>
<p class="TOC-AHD"><span href="#/c37" title="Link target outside of Sample">Porky piggies</span></p>
<p class="TOC-AHD"><span href="#/c38" title="Link target outside of Sample">Mooing cows</span></p>
<p class="TOC-AHD"><span href="#/c39" title="Link target outside of Sample">Playful pups</span></p>
<p class="TOC-AHD"><span href="#/c40" title="Link target outside of Sample">Busy blackbirds</span></p>
<p class="TOC-AHD"><span href="#/c41" title="Link target outside of Sample">Spaced out</span></p>
<p class="TOC-AHD"><span href="#/c42" title="Link target outside of Sample">Blast off!</span></p>
<p class="TOC-AHD"><span href="#/c43" title="Link target outside of Sample">Space explorers</span></p>
<p class="TOC-AHD"><span href="#/c44" title="Link target outside of Sample">Celestial sensation</span></p>
<p class="TOC-AHD"><span href="#/c45" title="Link target outside of Sample">Alien invasion</span></p>
<h2 class="TOC-CH-T"><span href="#/c46" title="Link target outside of Sample">Dressing up</span></h2>
<p class="TOC-AHD"><span href="#/c47" title="Link target outside of Sample">Red alert!</span></p>
<p class="TOC-AHD"><span href="#/c48" title="Link target outside of Sample">Cops &amp; robbers</span></p>
<p class="TOC-AHD"><span href="#/c49" title="Link target outside of Sample">Super troopers</span></p>
<p class="TOC-AHD"><span href="#/c50" title="Link target outside of Sample">Doctors &amp; nurses</span></p>
<p class="TOC-AHD"><span href="#/c51" title="Link target outside of Sample">Pop idols</span></p>
<h2 class="TOC-CH-T"><span href="#/c52" title="Link target outside of Sample">Fairytales &amp; adventure</span></h2>
<p class="TOC-AHD"><span href="#/c53" title="Link target outside of Sample">Wicked pirates</span></p>
<p class="TOC-AHD"><span href="#/c54" title="Link target outside of Sample">Magical mermaids</span></p>
<p class="TOC-AHD"><span href="#/c55" title="Link target outside of Sample">Fabulous fairies</span></p>
<p class="TOC-AHD"><span href="#/c56" title="Link target outside of Sample">Gallant knights</span></p>
<h2 class="TOC-FBMHD"><span href="#/c57" title="Link target outside of Sample">Sugarpaste quantities &amp; colourings</span></h2>
<h2 class="TOC-FBMHD"><span href="#/supp" title="Link target outside of Sample">Suppliers</span></h2>
<h2 class="TOC-FBMHD"><span href="#/cop" title="Link target outside of Sample">Copyright</span></h2>
<h2 class="TOC-FBMHD"><a href="http://www.stitchcraftcreate.co.uk/bookclub" target="_blank">Bookstore</a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?dbac74c8